export const version = "bytes/5.6.1";
//# sourceMappingURL=_version.js.map